import React from 'react';
import { Link } from 'react-router-dom';

function CoffreDashboard() {
  return (
    <div className="container mt-5">
      <h2 className="text-center mb-4">💰 Mon Coffre Fort</h2>

      <div className="row g-4">
        {/* 🛒 Acheter un pack */}
        <div className="col-md-6">
          <Link to="/packs" className="text-decoration-none">
            <div className="card bg-dark text-white shadow-sm h-100">
              <div className="card-body">
                <h5 className="card-title">🛒 Acheter un pack</h5>
                <p className="card-text">Choisissez un pack de pièces à acheter.</p>
              </div>
            </div>
          </Link>
        </div>

        {/* 🎁 Cadeaux reçus */}
<div className="col-md-6">
  <Link to="/cadeaux-recus" className="text-decoration-none">
    <div className="card bg-dark text-white shadow-sm h-100">
      <div className="card-body">
        <h5 className="card-title">🎁 Cadeaux reçus</h5>
        <p className="card-text">
          Consultez les cadeaux que vous avez reçus.
        </p>
      </div>
    </div>
  </Link>
</div>


      {/* 💸 Retirer des coins */}
<div className="col-md-6">
  <Link to="/retrait" className="text-decoration-none">
    <div className="card bg-dark text-white shadow-sm h-100">
      <div className="card-body">
        <h5 className="card-title">💸 Retirer des coins</h5>
        <p className="card-text">
          Transférez vos coins disponibles hors de l’app.
        </p>
      </div>
    </div>
  </Link>
</div>

        {/* 📜 Historique */}
        <div className="col-md-6">
          <Link to="/coins/transactions" className="text-decoration-none">
            <div className="card bg-dark text-white shadow-sm h-100">
              <div className="card-body">
                <h5 className="card-title">📜 Historique</h5>
                <p className="card-text">Toutes vos transactions de pièces.</p>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default CoffreDashboard;
